<template>
    <draggable-fixed :element="'.lw-admin-btns-wrapper'" :dragTargets="['lw-admin-btns-wrapper']" :destroyOnTouchScreen="true" v-if="navigationTooltipDisplay" >
        <div class="lw-admin-btns-wrapper" title="authoring options" @click="setNavigationLinksDisplay(!navigationLinksDisplay)" >
            <div class="lw-admin-btns" v-show="navigationLinksDisplay">
                <!--<div class="close dark-gray-close" @click.stop="setNavigationLinksDisplay(false)"></div>-->
                <div v-for="link in visibleLinks" :class="link.classes">
                    <span class="lw-admin-btn-icon"></span>
                    <a class="lw-admin-btn-lbl" @click.prevent="navigate(link)" :href="link.href">{{link.title}}</a>
                </div>
            </div>
        </div>
    </draggable-fixed>
</template>
<script>
    import DraggableFixed from "../../commonjs/DraggableFixed/DraggableFixed";
    import {mapGetters, mapState} from 'vuex';
    import {getUrlParams} from "../../commonjs/utils/UrlHandler";

    export default {
        name: "AdminNavigationTooltip",
        data() {
            return {
                navigationLinksDisplay: false,
                urlParams: {},
                urlSearch: "",
                pathname: "",
                affiliateEnabled: JSON.parse(window.SITE_AFFILIATES).active
            }
        },
        created () {
            this.urlParams = getUrlParams(document.location.href);
            this.pathname = document.location.pathname;
            this.urlSearch = document.location.search;
        },
        computed: {
            ...mapGetters('user',[
                'isAdmin',
                'isAffiliate',
                'isInstructor',
                'isInstructorIn',
                'isAnalytics',
            ]),
            ...mapState('pages', [
                'pageContext',
                'previewSiteTemplateId'
            ]),
            ...mapState('siteTemplate',[
                'currentSiteTemplate'
            ]),
            availableLinks () {
                let links = [
                    {
                        key: "dashboard",
                        title: "School Dashboard",
                        href: "/author/dashboard",
                        visible: this.isAdmin,
                        classes: ['lw-admin-btn', '-manage-school'],
                    },
                    {
                        key: "instructor_dashboard",
                        title: "Manage your courses",
                        href: "/author/courses",
                        visible: this.isInstructor,
                        classes: ['lw-admin-btn', '-edit-page'],
                    },
                    {
                        key: "affiliate",
                        title: "Affiliate dashboard",
                        href: '/author/affiliate?tab=dashboard',
                        visible: this.isAffiliate,
                        classes: ['lw-admin-btn', '-edit-page'],
                    },
                    {
                        key: "analytics",
                        title: "User Progress",
                        href: "/author/userprogress",
                        visible: this.isAnalytics,
                        classes: ['lw-admin-btn', '-edit-page'],
                    },
                    {
                        key: "page",
                        title: "Edit page",
                        href: this.getPageAuthoringLink(),
                        visible: this.inPagesbuilderPage && this.isAdmin,
                        classes: ['lw-admin-btn', '-edit-page'],
                    },
                    {
                        key: "course",
                        title: "Edit course",
                        href: this.getCourseAuthoringLink(),
                        visible: this.inCoursePage && (this.isAdmin || this.isCurrentCourseInstructor),
                        classes: ['lw-admin-btn', '-edit-page'],
                    },
                    {
                        key: "bundle",
                        title: "Edit bundle",
                        href: this.getPageAuthoringLink(),
                        visible: this.inBundlePage && this.isAdmin,
                        classes: ['lw-admin-btn', '-edit-page'],
                    },
                    {
                        key: "subscription",
                        title: "Edit subscription",
                        href: this.getPageAuthoringLink(),
                        visible: this.inSubscriptionPage && this.isAdmin,
                        classes: ['lw-admin-btn', '-edit-page'],
                    },
                    {
                        key: "dailynews",
                        title: "Edit feed",
                        href: '/author/news',
                        visible: this.inDailyNewsPage && this.isAdmin,
                        classes: ['lw-admin-btn', '-edit-page'],
                    },
                    {
                        key: "workpad",
                        title: "Best resources",
                        href: '/author/workpad',
                        visible: this.inWorkpad && this.isAdmin,
                        classes: ['lw-admin-btn', '-edit-page'],
                    },
                    {
                        key: "social",
                        title: "Edit social",
                        href: '/author/social',
                        visible: this.inSocial && this.isAdmin,
                        classes: ['lw-admin-btn', '-edit-page'],
                    },
                    {
                        key: "blogPost",
                        title: "Edit blog post",
                        href: this.getPageAuthoringLink(),
                        visible: this.inBlogPost && this.isAdmin,
                        classes: ['lw-admin-btn', '-edit-page'],
                    },
                    {
                        key: "blog",
                        title: "Edit blog home",
                        href: this.getPageAuthoringLink(),
                        visible: this.inBlogHome && this.isAdmin,
                        classes: ['lw-admin-btn', '-edit-page'],
                    },

                ];

                return links;
            },
            visibleLinks () {
                return this.availableLinks.filter(link => !!link.visible);
            },
            navigationTooltipDisplay () {
                return this.visibleLinks.length > 0;
            },
            isCurrentCourseInstructor () {
                if (!this.inCoursePage) {
                    return false;
                }
                const currentCourseTitleId = (window.pageState && window.pageState.slug) || this.pathname.replace('/course/','');
                return this.isInstructorIn && this.isInstructorIn.find(course => course.courseTitleId === currentCourseTitleId);
            },

            /**
             * Possible page types (from Model/Page.php):
             * page [includes legacy + apps], home, start,
             * course, bundle, subscription,
             * privacy, terms, courses, payment, blog,
             * thankyou, cookies, affiliate-program-terms, affiliate-registration
             *
             */

            // app/legacy pages with pageContext.type: page
            inDailyNewsPage () {
                return this.pathname.indexOf('/dailynews') === 0;
            },
            inWorkpad () {
                return this.pathname.indexOf('/workpad') === 0;
            },
            inSocial () {
                return this.pathname.indexOf('/social') === 0;
            },
            inPeople () {
                return this.pathname.indexOf('/people') === 0;
            },
            inAccount () {
                return this.pathname.indexOf('/account') === 0;
            },
            inInbox () {
                return this.pathname.indexOf('/inbox') === 0;
            },
            inProfile () {
                return this.pathname.indexOf('/profile') === 0;
            },
            inLegacyPage () {
                return this.inDailyNewsPage || this.inWorkpad || this.inSocial || this.inPeople || this.inAccount || this.inInbox || this.inProfile;
            },

            // pagebuilder pages
            inNormalPage () {
                return this.pageContext.type === 'page' && !this.inLegacyPage;
            },
            inPresetPage () {
                // various preset(?) pagebuilder pages with pageContext.type other than 'page'
                const presetPageTypes = [
                    'privacy',
                    'terms',
                    'courses',
                    'payment',
                    'thankyou',
                    'cookies',
                    'affiliate-program-terms',
                    'affiliate-registration',
                ]
                return presetPageTypes.indexOf(this.pageContext.type) > -1;
            },
            inLandingPage () {
                return this.pageContext.type === 'home';
            },
            inAfterLoginPage () {
                return this.pageContext.type === 'start';
            },
            inPagesbuilderPage () {
                return this.inNormalPage || this.inLandingPage || this.inAfterLoginPage || this.inPresetPage;
            },
            inBlogPost () {
                return this.pageContext.type === 'blog_post';
            },
            inBlogHome () {
                return this.pageContext.type === 'blog';
            },

            // products
            inCoursePage () {
                return this.pageContext.type === 'course';
            },
            inBundlePage () {
                return this.pageContext.type === 'bundle';
            },
            inSubscriptionPage () {
                return this.pageContext.type === 'subscription';
            },
            previewSiteTemplateParam(){
                if(!this.previewSiteTemplateId){
                    return '';
                }
                return `&site_template=${this.previewSiteTemplateId}`
            }
        },
        methods: {
            navigate(link) {
                if (link.key === 'affiliate' && !this.affiliateEnabled) {
                    showMessage(
                        'warning',
                        'Affiliate system de-activated',
                        "The affiliate system is de-activated, please contact school administrator for more info"
                    );
                    return;
                }
                window.location.href = link.href;
            },
            setNavigationLinksDisplay (flag) {
                this.navigationLinksDisplay = flag;
            },
            getPageAuthoringLink () {
                if (this.inLegacyPage) {
                    // legacy page authoring links are standard, we should not be looking for them here
                    return '';
                }

                const pageSlug = (window.pageState && window.pageState.slug) || this.getPageSlugFromUrl();

                return `/author/pageseditor?page=${pageSlug}&type=${this.pageContext.type}${this.previewSiteTemplateParam}&from=admin-navigation-tooltip`;
            },
            getCourseAuthoringLink () {
                const courseTitleId = (window.pageState && window.pageState.slug) || this.pathname.replace('/course/','');

                return `/author/course?courseid=${courseTitleId}${this.previewSiteTemplateParam}`;
            },
            getPageSlugFromUrl () {
                // this is a fallback way to get page slug if pageState doesn't work for some reason

                let pageSlug = '';

                if (!this.inPagesbuilderPage) {
                    return pageSlug;
                }

                if (this.inLandingPage) {
                    pageSlug = 'home';
                } else if (this.inAfterLoginPage) {
                    pageSlug = 'start';
                } else if (this.pathname.indexOf('/pages') === 0) {
                    pageSlug = this.pathname.replace('/pages/','');
                } else {
                    // this is for pages created with new pagebuilder so their url might not include /pages/ part we had in old pagebuilder
                    pageSlug = this.pathname.replace('/','');
                }

                return pageSlug;
            },
        },
        components: {
            DraggableFixed
        }
    }
</script>
